goog.provide('el8.app.shared.dialog.enterpriseImportPatient');

goog.require('el8.data.practiceUsers');
goog.require('el8.service.urls');
goog.require('el8.template.app.shared.dialog.enterpriseImportPatient');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.util.amplitude.collaborativePracticeHelpers');

/**
 * "Breaking the seal" for enterprise charts not yet in our practice
 */
el8.app.shared.dialog.enterpriseImportPatient = (function() {

    var yesCallbackFn, noCallbackFn, otherPatientId;
    var callerLocation; // a string for logging, describing where we're being called from

    function mapUserIdToPhysicianId(userId) {
        var physicianUserId = Number(userId);
        var physician = el8.data.practiceUsers.getById(physicianUserId);
        return physician.getStaffId();
    }

    var that = new el8.uiwidget.FormDialog({
        title: 'Add Patient to Your Practice',
        modal: true,
        autoHeight: true,
        width: 400,
        contentFn: function() {
            return el8.template.app.shared.dialog.enterpriseImportPatient.content({
                physicianUsers: el8.data.practiceUsers.getPhysicianUsers(),
                enterpriseName: el8.data.currPractice.getEnterpriseName()
            });
        }
    });

    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'primaryPhysicianUserId',
                selector: ':input[name="primaryPhysicianUserId"]',
                validate: {
                    required: true
                },
                changeFn: function(event) {
                    var physicianId = mapUserIdToPhysicianId(event.target.value);
                    el8.util.amplitude.logAddPatientToPracticeProviderSelect(physicianId);
                },
            }
        ],
        validationOpts: el8.util.validate.standardOpts
    });

    form.addButton('import', 'Agree & Continue', function(_form) {
        if (!form.isValid()) {
            el8.uiwidget.alert('Please select a provider for this patient');
            return;
        }

        form.disable();
        var $loadingDiv = $('.loading-indicator', that.getContentElt());
        $loadingDiv.addClass('el8Loading');
        that.adjustPosition();
        el8.appservice.notifier.notify('Adding patient to your practice...');

        var data = {'primary_physician_user_id': form.getVal('primaryPhysicianUserId')};
        
        el8.util.amplitude.logAddPatientToPractice({
            addPatientButton: 'Agree & Continue',
            changePhysicianId: mapUserIdToPhysicianId(data.primary_physician_user_id),
        });

        $.el8_longPoll({
            url: el8.service.urls.get('enterpriseImportPatient', [otherPatientId]),
            data: JSON.stringify(data),
            success: function(data) {
                var newPatient = el8.ptdata.patients.getById(data.new_patient_id);
                el8.appservice.notifier.notify('Patient added to your practice...');
                if (yesCallbackFn) { yesCallbackFn(data.new_patient_id, data.imported_lhs, newPatient); }

                that.hide();
                form.enable();
                $loadingDiv.removeClass('el8Loading');
            },
            error: function() {
                form.enable();
                $loadingDiv.removeClass('el8Loading');
                that.adjustPosition();
            }
        });
    }, true);
    form.addCancelButton(function() {
        if (noCallbackFn) { noCallbackFn(); }
        
        var data = {'primary_physician_user_id': form.getVal('primaryPhysicianUserId')};
        el8.util.amplitude.logAddPatientToPractice({
            addPatientButton: 'Cancel',
            changePhysicianId: mapUserIdToPhysicianId(data.primary_physician_user_id),
        });
        that.hide();
    });
    that.setForm(form);

    var super_show = that.show;
    that.show = function(spec) {
        spec = spec || {};
        yesCallbackFn = spec.yesCallbackFn || null;
        noCallbackFn = spec.noCallbackFn || null;
        otherPatientId = spec.patientId;
        callerLocation = spec.location;
        super_show.call(that);

        if (el8.data.currUser.isPhysician()) {
            form.setVal('primaryPhysicianUserId', el8.data.currUser.getId());
        }
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        yesCallbackFn = null;
        otherPatientId = null;
    };


    return that;

})();
